import SelectStatus from "components/select/status";
import useTableFilters from "@/hooks/useTableFilters";
import CalendarDatePicker from "ui/components/comp-507";
import { formatDateForAPI } from "utils/utils";
import { EMPLOYEE_FILTERS } from "components/employee/constants";
import UserCombobox from "components/directus/combobox/user";
import FilterWrapper from "components/filter/wrapper";
import FilterActions from "components/filter/actions";

export default function ReportBillableFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  clearFilters,
  defaultFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
    setLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      coordinator: undefined,
      status: undefined,
      project: undefined,
      job: undefined,
      billing_date: undefined,
      due_date: undefined,
      ...defaultFilters,
    },
  });

  return (
    <div className="w-full px-4 space-y-4">
      <FilterWrapper label="Job Coordinator">
        <UserCombobox
          value={localFilters.job?.coordinator?._eq}
          onChange={(selectedItem) =>
            setLocalFilters({
              ...localFilters,
              job: {
                ...localFilters.job,
                coordinator: {
                  _eq: selectedItem,
                },
              },
            })
          }
          filter={EMPLOYEE_FILTERS.jobs_coordinating}
          dependenton={isOpen}
        />
      </FilterWrapper>

      <FilterWrapper label="Sales Coordinator">
        <UserCombobox
          value={localFilters.job?.project?.sales_coordinator?._eq}
          onChange={(selectedItem) =>
            setLocalFilters({
              ...localFilters,
              job: {
                ...localFilters?.job,
                project: {
                  sales_coordinator: {
                    _eq: selectedItem,
                  },
                },
              },
            })
          }
          filter={EMPLOYEE_FILTERS.sales_coordinating}
          dependenton={isOpen}
        />
      </FilterWrapper>

      <FilterWrapper label="Status">
        <SelectStatus
          collection="billables"
          value={localFilters?.status?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              ...localFilters,
              status: { _eq: selectedItem },
            });
          }}
        />
      </FilterWrapper>

      <FilterWrapper label="Billing Date">
        <CalendarDatePicker
          stack={true}
          disabled={false}
          date={{
            from: localFilters?.billing_date?._gte,
            to: localFilters?.billing_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              billing_date: {
                _gte: range?.from ? formatDateForAPI(range.from) : undefined,
                _lte: range?.to ? formatDateForAPI(range.to) : undefined,
              },
            });
          }}
          className="w-full"
        />
      </FilterWrapper>

      <FilterWrapper label="Due Date">
        <CalendarDatePicker
          stack={true}
          disabled={false}
          date={{
            from: localFilters?.due_date?._gte,
            to: localFilters?.due_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              due_date: {
                _gte: range?.from ? formatDateForAPI(range.from) : undefined,
                _lte: range?.to ? formatDateForAPI(range.to) : undefined,
              },
            });
          }}
          className="w-full"
        />
      </FilterWrapper>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </div>
  );
}
